import { ReactNode } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { Form, FormField, PhoneField } from 'components/form';

import { PersonaBucket } from '../../personas';
import { WaitlistFormValues } from '../schema';
import * as styled from '../styles/hero';

type Props = {
  bucket: PersonaBucket;
  form: UseFormReturn<WaitlistFormValues>;
  formSuccess: boolean;
  formError: string | null;
  onSubmit: (values: WaitlistFormValues) => Promise<void> | void;
};

const SUB_COPY: Record<PersonaBucket, ReactNode> = {
  social: (
    <>
      Your followers book through{' '}
      <styled.HeroSubAccent>
        the link in your bio, stories, or statuses
      </styled.HeroSubAccent>
      . New clients find you by searching the{' '}
      <styled.HeroSubAccent>Kudable marketplace</styled.HeroSubAccent>. Your
      reviews close the deal.
    </>
  ),
  trade: (
    <>
      Clients book through{' '}
      <styled.HeroSubAccent>
        your link — shared anywhere
      </styled.HeroSubAccent>{' '}
      — or find you on the{' '}
      <styled.HeroSubAccent>Kudable marketplace</styled.HeroSubAccent>. Real
      clients. Real bookings. Real money.
    </>
  ),
};

export const Hero = ({
  bucket,
  form,
  formSuccess,
  formError,
  onSubmit,
}: Props) => (
  <styled.HeroWrap>
    <styled.Hero>
      <styled.HeroLeft>
        <styled.HeroHeading>
          Fill your calendar with{' '}
          <styled.HeroAccent>paying clients.</styled.HeroAccent>
        </styled.HeroHeading>
        <styled.HeroSub>{SUB_COPY[bucket]}</styled.HeroSub>
      </styled.HeroLeft>
      <styled.HeroRight>
        <styled.WaitlistCard id="waitlist">
          {formSuccess ? (
            <styled.WaitlistSuccess>
              🎉 Spot claimed! We'll be in touch to help set up your profile.
            </styled.WaitlistSuccess>
          ) : (
            <>
              <styled.HeroFormHeading>Claim your profile</styled.HeroFormHeading>
              <styled.HeroFormSub>
                Kudable is live. Claim your spot, start collecting reviews
                today, and show up in search from day one.
              </styled.HeroFormSub>
              <Form form={form} onSubmit={onSubmit}>
                <FormField
                  name="name"
                  label="Full name"
                  placeholder="e.g. John Smith"
                />
                <FormField
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="you@email.com"
                />
                <PhoneField
                  name="phone"
                  label="Phone / WhatsApp (optional)"
                  placeholder="e.g. 415 555 2671"
                />
                {formError && (
                  <styled.WaitlistError>{formError}</styled.WaitlistError>
                )}
                <styled.WaitlistButton
                  type="submit"
                  disabled={form.formState.isSubmitting}
                >
                  {form.formState.isSubmitting
                    ? 'Claiming...'
                    : 'Claim my profile →'}
                </styled.WaitlistButton>
                <styled.FormReassure>
                  Free to start · No card needed · Cancel anytime
                </styled.FormReassure>
              </Form>
            </>
          )}
        </styled.WaitlistCard>
      </styled.HeroRight>
    </styled.Hero>
  </styled.HeroWrap>
);
